import React from 'react'
import { Stack, TextField, Typography } from '@mui/material'
import useTranslation from '../../../../hooks/useTranslation'

export default function SectionSpacingFields({
  settings,
  onChange,
  topLabel,
  bottomLabel,
  topField = 'spacingTop',
  bottomField = 'spacingBottom',
}) {
  const { t } = useTranslation()

  return (
    <Stack spacing={1.5}>
      <Typography variant="caption" color="text.secondary">
        {t('labels.themes.sectionSpacing')}
      </Typography>

      <Stack direction="row" spacing={2}>
        <TextField
          label={topLabel || t('labels.themes.topSpacing')}
          type="number"
          size="small"
          fullWidth
          inputProps={{ min: 0, max: 200 }}
          value={settings[topField] ?? 0}
          onChange={(e) =>
            onChange({
              ...settings,
              [topField]: parseInt(e.target.value, 10) || 0
            })
          }
        />

        <TextField
          label={bottomLabel || t('labels.themes.bottomSpacing')}
          type="number"
          size="small"
          fullWidth
          inputProps={{ min: 0, max: 200 }}
          value={settings[bottomField] ?? 0}
          onChange={(e) =>
            onChange({
              ...settings,
              [bottomField]: parseInt(e.target.value, 10) || 0
            })
          }
        />
      </Stack>
    </Stack>
  )
}